import i18n from '@/lang/i18n'

export enum SidebarTimeFilterType {
    TODAY = 'today',
    THIS_WEEK = 'thisWeek',
    THIS_MONTH = 'thisMonth',
    THIS_QUARTER = 'thisQuarter',
    THIS_YEAR = 'thisYear'
}

export interface SidebarTimeFilter {
    value: SidebarTimeFilterType
    text: string
    disabled?: boolean // default: false
}

export const defaultSidebarTimeFilterSelectedOption = SidebarTimeFilterType.THIS_WEEK
export const defaultSidebarTimeFilterOptions =
    (): Array<SidebarTimeFilter> => [
        { value: SidebarTimeFilterType.TODAY, text: i18n.tc('global.dateTarget.today') },
        { value: SidebarTimeFilterType.THIS_WEEK, text: i18n.tc('global.dateTarget.thisWeek') },
        { value: SidebarTimeFilterType.THIS_MONTH, text: i18n.tc('global.dateTarget.thisMonth') },
        { value: SidebarTimeFilterType.THIS_QUARTER, text: i18n.tc('global.dateTarget.thisQuarter') },
        { value: SidebarTimeFilterType.THIS_YEAR, text: i18n.tc('global.dateTarget.thisYear') }
    ]
